import React, { Component } from 'react'

import PlantCareRow from './PlantCareRow'
import { DevicesRow } from '../StyledComponents/Devices/DeviceList'

const mapValueToString = (value) => {
    if (!value) {
        return ''
    }
    switch (value.toUpperCase()) {
        case 'SUN':
            return 'Sonne'
        case 'SHADE':
            return 'Schatten'
        case 'HALF_SHADE':
            return 'Halbschatten'
        case 'HIGH':
            return 'Hoch'
        case 'AVERAGE':
            return 'Durchschnittlich'
        case 'LOW':
            return 'Gering'
        case 'SPRING':
            return 'Frühling'
        case 'SUMMER':
            return 'Sommer'
        case 'WINTER':
            return 'Winter'
        case 'AUTUMN':
            return 'Herbst'
        case 'NOT_SPECIFIED':
            return ''
        default:
            return value
    }
}

class PlantCareRows extends Component {
    render() {
        const { plant } = this.props

        return (
            <DevicesRow>
                <PlantCareRow title="Standort" value={mapValueToString(plant.place)} icon={plant.place} />
                <PlantCareRow title="Wasserbedarf" value={mapValueToString(plant.water_demand)} icon={plant.water_demand} />
                <PlantCareRow title="Schnittzeit" value={mapValueToString(plant.cutting_time)} icon={plant.cutting_time} />
                <PlantCareRow
                    title="Dünghäufigkeit"
                    value={plant.fertilizing_frequency && plant.fertilizing_frequency_unit ? `${plant.fertilizing_frequency} Mal / ${plant.fertilizing_frequency_unit}` : ''}
                    icon="FERTILIZER"
                />
                <PlantCareRow title="Wuchshöhe" value={plant.height ? `${plant.height} cm` : ''} icon="HEIGHT" />
                <PlantCareRow title="Blütezeit" value={plant.florescence} icon="FLORESCENSE" />
                <PlantCareRow title="Bodentyp" value={plant.soil_type ? plant.soil_type.localized_name : ''} icon="TERRAIN" />
            </DevicesRow>

        )
    }
}

export default PlantCareRows



// WEBPACK FOOTER //
// ./src/components/Plant/PlantCareRows.js